import { Link } from 'react-router-dom';
import { weeklyRankings, hotAuthors, forumStats, announcements as announcementsData } from '@/mocks/rankings';
import { announcements } from '@/mocks/announcements';

export default function Sidebar() {
  return (
    <aside className="space-y-5">
      <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2 font-heading">
          <i className="ri-bar-chart-2-line text-primary-500"></i>社区数据
        </h4>
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-background-100 rounded-lg p-3 text-center">
            <div className="text-lg font-bold text-primary-600 font-heading">{(forumStats.totalMembers / 10000).toFixed(0)}万</div>
            <div className="text-xs text-foreground-500 mt-0.5">注册会员</div>
          </div>
          <div className="bg-background-100 rounded-lg p-3 text-center">
            <div className="text-lg font-bold text-accent-600 font-heading">{(forumStats.totalPosts / 10000).toFixed(0)}万</div>
            <div className="text-xs text-foreground-500 mt-0.5">帖子总数</div>
          </div>
          <div className="bg-background-100 rounded-lg p-3 text-center">
            <div className="text-lg font-bold text-primary-600 font-heading">{forumStats.onlineUsers.toLocaleString()}</div>
            <div className="text-xs text-foreground-500 mt-0.5">当前在线</div>
          </div>
          <div className="bg-background-100 rounded-lg p-3 text-center">
            <div className="text-lg font-bold text-accent-600 font-heading">{forumStats.todayPosts.toLocaleString()}</div>
            <div className="text-xs text-foreground-500 mt-0.5">今日新帖</div>
          </div>
        </div>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2 font-heading">
          <i className="ri-fire-line text-primary-500"></i>周榜热文
        </h4>
        <ul className="space-y-3">
          {weeklyRankings.map((item) => (
            <li key={item.rank} className="flex items-start gap-3">
              <span className={`flex-shrink-0 w-5 h-5 flex items-center justify-center rounded text-xs font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <div className="min-w-0">
                <Link
                  to={`/article/${item.rank}`}
                  className="text-sm text-foreground-800 hover:text-primary-600 transition-colors line-clamp-2 leading-snug"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  {item.title}
                </Link>
                <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span>·</span>
                  <span>{item.reads.toLocaleString()} 阅读</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2 font-heading">
          <i className="ri-notification-3-line text-primary-500"></i>论坛公告
        </h4>
        <ul className="space-y-3">
          {announcements.map((item) => (
            <li key={item.id}>
              <Link
                to={item.link}
                className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors leading-snug"
              >
                {item.isImportant && (
                  <span className="inline-block w-1.5 h-1.5 bg-primary-500 rounded-full mr-1.5 align-middle"></span>
                )}
                {item.title}
              </Link>
              <span className="text-xs text-foreground-500 mt-1 block">{item.date}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2 font-heading">
          <i className="ri-user-star-line text-primary-500"></i>热门作者
        </h4>
        <ul className="space-y-3">
          {hotAuthors.map((author) => (
            <li key={author.name} className="flex items-center gap-3">
              <img
                src={author.avatar}
                alt={author.name}
                className="w-9 h-9 rounded-full object-cover flex-shrink-0"
                width="36"
                height="36"
              />
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground-800">{author.name}</div>
                <div className="text-xs text-foreground-500">
                  {author.articles}篇 · {author.followers.toLocaleString()}粉丝
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}